/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Load_TitleInputs */

const en_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load Audio Description Export Preset`)
};

const fr_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger un préréglage d'exportation de description audio`)
};

const de_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung laden Voreinstellung exportieren`)
};

const it_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica preimpostazione di esportazione della descrizione audio`)
};

const ru_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить аудиоописание Экспорт предустановки`)
};

const es_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar ajuste preestablecido de exportación de descripción de audio`)
};

const zh_cn2_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载音频描述导出预设`)
};

const ja_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明エクスポートプリセットを読み込む`)
};

const hi_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात प्रीसेट लोड करें`)
};

const pt_pt2_audio_description_export_preset_load_title = /** @type {(inputs: Audio_Description_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar predefinição de exportação de audiodescrição`)
};

/**
* | output |
* | --- |
* | "Load Audio Description Export Preset" |
*
* @param {Audio_Description_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_load_title = /** @type {((inputs?: Audio_Description_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_load_title(inputs)
	if (locale === "de") return de_audio_description_export_preset_load_title(inputs)
	if (locale === "it") return it_audio_description_export_preset_load_title(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_load_title(inputs)
	if (locale === "es") return es_audio_description_export_preset_load_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_load_title(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_load_title(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_load_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_load_title(inputs)
	return en_audio_description_export_preset_load_title(inputs)
});